<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" class="mc-page-three" />
      <p class="mb-4">
        {{ $t('master.list.rfid.tag.showHistory') }}
        <strong>{{ rfid }}</strong>
      </p>

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <McButtonBack href="/master/rfid" />
      </div>
    </div>
    <McGrapqlTable
      :apiClient="query"
      :fields="fields"
      :hasCheckbox="false"
      :searchable="true"
      :hasBilingual="true"
      :withCard="true"
    >
      <template #cell(time)="data">
        {{ data.item ? momentDateShortMonth(data.item.time) : '-' }}<br />
        <span v-if="data.item.time" class="text-muted">{{
          data.item ? momentTimeSeconds(data.item.time) : '-'
        }}</span>
      </template>
      <template #cell(action)="data">
        {{ data.item.action ?? '-' }}
      </template>
      <template #cell(detail)="data">
        <div v-html="sanitizedDetail(data.item)"></div>
      </template>
      <template #cell(user)="data">
        {{ data.item.user ?? '-' }}
      </template>
    </McGrapqlTable>
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import McGrapqlTable from '@/components/McGrapqlTable'
import McButtonBack from '@/components/McButtonBack'
import { Helper } from '@/mixin/helper'
import { GET_RFID_LOGS } from '@/services/api/master/rfid'
import DOMPurify from 'dompurify'

export default {
  page: {
    title: 'Change History',
    meta: [{ name: 'description', content: appConfig.description }],
  },

  components: {
    Layout,
    PageHeader,
    McGrapqlTable,
    McButtonBack,
  },

  mixins: [Helper],

  data() {
    return {
      rfid: this.$route.params.id,
      lastOrderBy: null,
    }
  },

  computed: {
    title() {
      return this.$t('master.list.rfid.tag.changeHistory')
    },
    fields() {
      return [
        {
          key: 'time',
          label: this.$t('setting.list.managementAsset.gps.changeDate'),
          isSortable: true,
          isLocked: false,
        },
        {
          key: 'action',
          label: this.$t('master.form.fleet.changeHistory.descriptionChange'),
          isSortable: true,
          isLocked: false,
        },
        {
          key: 'detail',
          label: this.$t('master.form.fleet.changeHistory.information'),
          isSortable: true,
          isLocked: false,
        },
        {
          key: 'user',
          label: this.$t('master.form.fleet.changeHistory.modifier'),
          isSortable: true,
          isLocked: false,
        },
      ]
    },
    query() {
      return {
        get: async (opts) => {
          const language = localStorage.getItem('language') === 'en' ? 'English' : 'Indonesia'
          if (opts.orderBy) {
            this.lastOrderBy = opts.orderBy
          }
          const res = await this.$apollo.query({
            query: GET_RFID_LOGS,
            variables: {
              filter: {
                rfid: this.rfid,
                orderBy: this.lastOrderBy,
                search: opts.search,
                language: language,
                pagination: {
                  page: opts.pagination.page,
                  show: opts.pagination.show,
                },
              },
            },
            fetchPolicy: 'no-cache',
          })
          return res.data.getRfidLogs.getRfidAuditLogs
        },
      }
    },
  },

  methods: {
    displayDetail(data) {
      if (!data.detail) {
        return '-'
      }

      const oldDataParts = data.oldData ? data.oldData.trim().split(/\s+/) : []
      const newDataParts = data.newData ? data.newData.trim().split(/\s+/) : []

      let detail = data.detail

      if (oldDataParts.length > 0) {
        oldDataParts.forEach((part) => {
          const regex = new RegExp(`(\\b${part}\\b)`, 'gi')
          detail = detail.replace(regex, '<strong>$1</strong>')
        })
      }

      if (newDataParts.length > 0) {
        newDataParts.forEach((part) => {
          const regex = new RegExp(`(\\b${part}\\b)`, 'gi')
          detail = detail.replace(regex, '<strong>$1</strong>')
        })
      }

      return detail
    },

    sanitizedDetail(data) {
      return DOMPurify.sanitize(this.displayDetail(data), {
        ALLOWED_TAGS: ['strong'],
        ALLOWED_ATTR: [],
      })
    },
  },
}
</script>
